@if (isButton) {
<button
  [attr.id]="id || null"
  [type]="htmlType"
  class="{{ type }} mat-ripple"
  [disabled]="isDisabled"
  (click)="handleClick($event)"
  formnovalidate
  matRipple
>
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</button>
} @if (!isButton) { @if (!disabled) { @if (link != null) {
<a
  [routerLink]="link"
  [queryParams]="queryParams"
  (click)="handleClick($event)"
  class="{{ type }}"
>
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</a>
} @if (href != null) {
<a
  [href]="href"
  (click)="handleClick($event)"
  rel="noopener noreferrer"
  target="_blank"
  class="{{ type }}"
>
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</a>
} } @if (disabled) {
<a class="disabled {{ type }}">
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</a>
} }

<ng-template #content>
  @if (showIcon) {
  <icon [type]="icon"></icon>
  } @if (showSpinner) {
  <mat-progress-spinner
    [diameter]="14"
    mode="indeterminate"
  ></mat-progress-spinner>
  }

  <ng-content></ng-content>
</ng-template>
